// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import dayjs from "dayjs";
// import { dateDurationList } from "../../utils";
// import CustomCheckbox from "../FormFields/Custom/CustomCheckbox";

// const InvoiceSidebar = ({ data = [], duration }) => {
//   const [openIndexes, setOpenIndexes] = useState([]);
//   const [openSubIndexes, setOpenSubIndexes] = useState({});
//   const [selectedValues, setSelectedValues] = useState([]); // Assuming selectedValues is an array of values

//   //  filter data based on duration

//   const handleToggle = (idx) => {
//     setOpenIndexes((prev) =>
//       prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
//     );
//   };
// console.log("selectedValues",selectedValues);
//   const handleSubToggle = (parentIdx, childIdx) => {
//     setOpenSubIndexes((prev) => {
//       const key = `${parentIdx}-${childIdx}`;
//       return {
//         ...prev,
//         [key]: !prev[key],
//       };
//     });
//   };
// console.log("data",data);
//   return (
//     <div className="w-full border-2 rounded-lg overflow-hidden flex flex-col gap-3">
//       <div className="bg-neutrals-500 text-white p-2 text-center rounded-b-lg">
//         {data[0]?.userName}
//       </div>
//       <div>
//         {data.map((item, index) => {
//           const isOpen = openIndexes.includes(index);
//           return (
//             <div key={index}>
//               <div
//                 className="collapsible flex justify-between items-center cursor-pointer bg-slate-100 p-2"
//                 onClick={() => handleToggle(index)}
//               >
//                 <div className="flex items-center gap-1">
//                   <span className="material-symbols-rounded leading-none">
//                     {isOpen ? "expand_more" : "expand_less"}
//                   </span>
//                   <div>{item.timeSheet.title}</div>
//                 </div>
//                 <div className="text-xs text-white bg-black rounded-full flex justify-center items-center leading-none w-6 h-6">
//                   {item.timeSheet.data.length}
//                 </div>
//               </div>
//               <AnimatePresence initial={false}>
//                 {isOpen && (
//                   <motion.div
//                     className="collapsible-content my-2"
//                     initial={{ opacity: 0, height: 0 }}
//                     animate={{ opacity: 1, height: "auto" }}
//                     exit={{ opacity: 0, height: 0 }}
//                     transition={{ duration: 0.3 }}
//                   >
//                     <div className="px-2 py-1 flex flex-col gap-2">
//                       {item.timeSheet.data.map((data, childIdx) => {
//                         const start = dayjs(
//                           data.period.from,
//                           "DD/MM/YYYY"
//                         );
//                         const end = dayjs(data.period.to, "DD/MM/YYYY");
//                         const monthDiff = end.diff(start, "month") + 1;

//                         const subKey = `${index}-${childIdx}`;
//                         const isSubOpen = openSubIndexes[subKey] || false;
//                         const list = dateDurationList(
//                           data.period.from,
//                           data.period.to
//                         );
//                         const convertedList = list.map((item, index) => {
//                           return {
//                             label: item,
//                             value: `${index}-${childIdx}-${item}`,
//                           };
//                         });

//                         return (
//                           <div key={childIdx}>
//                             <div
//                               className="flex-1 flex justify-between items-center ml-2 cursor-pointer"
//                               onClick={() => handleSubToggle(index, childIdx)}
//                             >
//                               <div className="flex items-center gap-2">
//                                 <span className="material-symbols-rounded text-sm leading-none">
//                                   {isSubOpen ? "expand_more" : "expand_less"}
//                                 </span>
//                                 <div>{data.company.name}</div>
//                               </div>
//                               <div className="flex items-center justify-between gap-2">
//                                 <div className="text-xs text-white bg-black rounded-full flex justify-center items-center leading-none w-6 h-6">
//                                   {monthDiff}
//                                 </div>
//                                 {/* <div className="text-sm text-white bg-black rounded-full flex justify-center items-center leading-none w-6 h-6">
//                                   {
//                                     selectedValues.filter((v) =>
//                                       v.includes(`-${childIdx}-`)
//                                     ).length
//                                   }
//                                 </div> */}
//                               </div>
//                             </div>
//                             <AnimatePresence initial={false}>
//                               {isSubOpen && (
//                                 <motion.div
//                                   className="text-sm text-gray-500 p-3"
//                                   initial={{ opacity: 0, height: 0 }}
//                                   animate={{ opacity: 1, height: "auto" }}
//                                   exit={{ opacity: 0, height: 0 }}
//                                   transition={{ duration: 0.3 }}
//                                 >
//                                   <div className="flex flex-col gap-2">
//                                     <CustomCheckbox
//                                       list
//                                       //size="sm"
//                                       color="warning"
//                                       options={convertedList}
//                                       selectedValues={selectedValues}
//                                       onChange={(e) => {
//                                         console.log(e);
//                                         setSelectedValues(e);
//                                       }}
//                                       multiple
//                                     />
//                                   </div>
//                                 </motion.div>
//                               )}
//                             </AnimatePresence>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default InvoiceSidebar;





import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import dayjs from "dayjs";
import CustomCheckbox from "../FormFields/Custom/CustomCheckbox";
import { invoiceFrequencyTypeOptions } from "../../assets/data/projectData";
import common from "../../utils/common";
import { exactUTCDate } from "../../utils/dateFormator";
const InvoiceSidebar = ({ data = [], selectedValues,handleSelectTimeDate,disabled=false }) => {
  const {formatRange}=common;
 const [openIndexes, setOpenIndexes] = useState(() =>
  Array.isArray(data) ? data.map((_, i) => i) : []
);
  const [openSubIndexes, setOpenSubIndexes] = useState({});

  //  filter data based on duration

  const handleToggle = (idx) => {
    setOpenIndexes((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };
  const handleSubToggle = (parentIdx, childIdx) => {
    setOpenSubIndexes((prev) => {
      const key = `${parentIdx}-${childIdx}`;
      return {
        ...prev,
        [key]: !prev[key],
      };
    });
  };
  return (
    <div className="w-full border-2 rounded-lg overflow-hidden flex flex-col gap-3">
      <div className="bg-neutrals-500 text-white p-2 text-center rounded-b-lg">
        {data[0]?.empName || ''}
      </div>
      <div>
        {data.map((item, index) => {
          const isOpen = openIndexes.includes(index);
          const datesCombine = item.ranges.flatMap((range, childIdx) => {
        //     const list = dateDurationList(range.from, range.to);
        //  console.log("list",list);
        //     return list.map((date, index) => ({
        //       label: date,
        //       value: range,
        //       uiid: item.uiid,
        //     }));

        return [{
          // label:formatRange(range.from, range.to),
          // label: `${dayjs(exactUTCDate(range.from)).format("MMM DD")} - ${dayjs(exactUTCDate(range.to)).format("MMM DD")} (${dayjs(exactUTCDate(range.to)).format("YYYY")})`,
          label: `${dayjs.utc(range.from).format("MMM DD")} - ${dayjs.utc(range.to).format("MMM DD")} (${dayjs.utc(range.to).format("YYYY")})`,
          uiid: item.uiid,
          value: range,
        }
        ]
          });
          return (
            <div key={index}>
              <div
                className="collapsible flex justify-between items-center cursor-pointer bg-slate-100 p-2"
                onClick={() => handleToggle(index)}
              >
                <div className="flex items-center gap-1">
                  <span className="material-symbols-rounded leading-none">
                    {isOpen ? "expand_more" : "expand_less"}
                  </span>
                  <div>{
                   invoiceFrequencyTypeOptions?.find(data => data.value === item?.type)?.label
                  }</div>
                </div>
                <div className="text-xs text-white bg-black rounded-full flex justify-center items-center leading-none w-6 h-6">
                  {item.ranges.length}
                </div>
              </div>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    className="collapsible-content my-2"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-2 py-1 flex flex-col gap-2">
                      <div>
                        <div className="flex-1 flex justify-between items-center ml-2 cursor-pointer">
                          <div className="flex items-center gap-2">
                            {/* <span className="material-symbols-rounded text-sm leading-none">
                              {isSubOpen ? "expand_more" : "expand_less"}
                            </span> */}
                            <div>{item.companyName || ''}</div>
                          </div>
                          {/* <div className="flex items-center justify-between gap-2">
                            <div className="text-xs text-white bg-black rounded-full flex justify-center items-center leading-none w-6 h-6">
                              {monthDiff}
                            </div>
                          </div> */}
                        </div>
                            <AnimatePresence initial={false}>
                            {/* {isSubOpen && ( */}
                            <motion.div
                              className="text-sm text-gray-500 p-3"
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{ duration: 0.3 }}
                            >
                              <div className="flex flex-col gap-2">
                                <CustomCheckbox
                                  list
                                  //size="sm"
                                  color="warning"
                                  options={datesCombine}
                                  selectedValues={selectedValues}
                                  onChange={(e) => {
                                    handleSelectTimeDate(e);
                                  }}
                                  multiple
                                  disabled={disabled}
                                />
                              </div>
                            </motion.div>
                            {/* //   )} */}
                          </AnimatePresence>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InvoiceSidebar;
